// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setDollarConversionLevels = createAction('[Custom PDF Report Modal] Set Dollar Conversion Levels', props());
